<div class="loa-page">
  <div class="p-3 p-lg-4 loa-shell">
    <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 align-items-xl-center">
      <div class="d-flex align-items-center gap-3">
        <span class="title-badge">
        <lucide-icon [img]="ShoppingCartIcon" [size]="17"></lucide-icon>
        </span>
        <div>
          <div class="loa-page-header__eyebrow">{{ pageHeadingKicker() }}</div>
          <h1 class="page-title-lite">{{ pageHeadingTitle() }}</h1>
        </div>
      </div>
      <button class="btn btn-dark btn-sm" type="button" (click)="router.navigateByUrl('/loas')">
        <lucide-icon [img]="ArrowLeftIcon" [size]="14"></lucide-icon><span class="ms-2">BACK</span>
      </button>
    </div>

    <div class="loa-hero-copy">
      <p class="page-subtitle-lite mb-0">
        Keep core LOA details, schedules, billing rules, and supporting documents in a single workflow with the same management theme used across the LOA module.
      </p>
    </div>

    @if (loaId() && loading() && !currentLoa()) {
      <div class="card card-lift mt-3">
        <div class="card-body py-5 text-center text-muted">
          {{ mode() === 'edit' ? 'Loading LOA for editing...' : 'Loading LOA details...' }}
        </div>
      </div>
    } @else {
      <form [formGroup]="form" (ngSubmit)="submit()" class="loa-form gap-3 mt-3">
        <div class="card card-lift">
          <div class="card-header bg-white fw-semibold">Basic Details</div>
          <div class="card-body">
            <div class="row g-2">
              <div class="col-md-3">
                <label class="form-label">Upload LOA Document</label>
                <input class="form-control" type="file" [disabled]="readOnly()" />
              </div>
              <div class="col-md-3">
                <label class="form-label">LOA Reference Number *</label>
                <input class="form-control" formControlName="loa_number" [readonly]="readOnly()" placeholder="Enter LOA Reference Number" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Entity *</label>
                <div class="input-group">
                  <select class="form-select" formControlName="vendor_id" [disabled]="readOnly()">
                    <option value="" disabled>Select Entity</option>
                    @for (vendor of vendors(); track vendor.id) {
                      <option [value]="vendor.id">{{ vendor.vendor_name }}</option>
                    }
                  </select>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    [disabled]="!form.controls.vendor_id.value"
                    (click)="openVendorPreview(form.controls.vendor_id.value)"
                  >
                    Preview
                  </button>
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Issue Date *</label>
                <input class="form-control" type="date" formControlName="issue_date" [readonly]="readOnly()" />
              </div>

              <div class="col-md-3">
                <label class="form-label">Effective From *</label>
                <input class="form-control" type="date" formControlName="effective_from" [readonly]="readOnly()" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Effective To *</label>
                <input class="form-control" type="date" formControlName="effective_to" [readonly]="readOnly()" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Type of LOA *</label>
                <select class="form-select" formControlName="loa_term" [disabled]="readOnly()">
                  <option value="" disabled>Select LOA Type</option>
                  @for (item of loaTermOptions; track item) { <option [value]="item">{{ item }}</option> }
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">LOA Lead *</label>
                <select class="form-select" formControlName="loa_lead" [disabled]="readOnly()">
                  <option value="" disabled>Select LOA Lead</option>
                  @for (item of loaLeadOptions; track item) {
                    <option [value]="item">{{ item }}</option>
                  }
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Is Provisional *</label>
                <select class="form-select" [value]="provisionalValue()" (change)="setProvisional(($any($event.target).value || '').toString())" [disabled]="readOnly()">
                  @for (item of provisionalStatusOptions; track item) {
                    <option [value]="item">{{ item }}</option>
                  }
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">Delivery Point *</label>
                <select class="form-select" formControlName="delivery_point" [disabled]="readOnly()">
                  <option value="" disabled>Select Delivery Point</option>
                  @for (item of deliveryPointOptions; track item) {
                    <option [value]="item">{{ item }}</option>
                  }
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">
                  Energy Type
                  @if (isEnergyTypeRequired()) {
                    <span>*</span>
                  }
                </label>
                @if (isGeneratorEntity()) {
                  <input class="form-control" formControlName="energy_type" placeholder="Auto-filled from entity subtype" readonly />
                } @else {
                  <select class="form-select" formControlName="energy_type" [disabled]="readOnly()">
                    <option value="">Select Energy Type</option>
                    @for (item of energyTypeOptions(); track item) {
                      <option [value]="item">{{ item }}</option>
                    }
                  </select>
                }
              </div>
              @if (isBanking()) {
                <div class="col-md-3">
                  <label class="form-label">Banking Priority *</label>
                  <select class="form-select" formControlName="banking_priority" [disabled]="readOnly()">
                    <option value="" disabled>Select Banking Priority</option>
                    @for (item of bankingPriorityOptions; track item) {
                      <option [value]="item">{{ item }}</option>
                    }
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Revision Limit (%)</label>
                  <input class="form-control" type="number" step="0.01" formControlName="revision_limit" [readonly]="readOnly()" placeholder="Enter Revision Limit" />
                </div>
              }
              <!-- <div class="col-md-3">
                <label class="form-label">State</label>
                <input class="form-control" formControlName="state" [readonly]="readOnly()" />
              </div> -->
            </div>
          </div>
        </div>

        <div class="card card-lift">
          <div class="card-header bg-white fw-semibold">Compensation</div>
          <div class="card-body d-grid gap-3">
            <div class="penalty-toggle-row">
              <label class="form-check-label d-flex align-items-center gap-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="penaltyApplicable()"
                  [disabled]="readOnly()"
                  (change)="setPenaltyApplicable($any($event.target).checked)"
                />
                Enable Compensation in LOA
              </label>
              <div class="small text-muted">Use fixed per-unit rate or quantum-wise shortfall slabs.</div>
            </div>

            @if (penaltyApplicable()) {
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">Compensation Mode *</label>
                  <select class="form-select" [value]="form.controls.penalty_mode.value" [disabled]="readOnly()" (change)="setPenaltyMode(($any($event.target).value || 'fixed_rate').toString())">
                    <option value="fixed_rate">Per Unit Fixed Rate</option>
                    <option value="quantum_wise">Quantum Wise</option>
                  </select>
                </div>

                @if (!isQuantumWisePenalty()) {
                  <div class="col-md-4">
                    <label class="form-label">Compensation Fixed Rate *</label>
                    <input class="form-control" type="number" step="0.01" formControlName="penalty_fixed_rate" [readonly]="readOnly()" placeholder="Example: 2.13" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Unit</label>
                    <input class="form-control" value="Rs per unit" readonly />
                  </div>
                }
              </div>

              @if (isQuantumWisePenalty()) {
                <div class="penalty-note">
                  Shortfall slabs apply on deviation against LOA quantum. Example: LOA quantum 500 MW, actual flow 450 MW, shortfall 50 MW.
                </div>
                <div class="row g-2 align-items-end">
                  <div class="col-md-3">
                    <label class="form-label">From Quantum (MW) *</label>
                    <input class="form-control" type="number" step="0.01" [formControl]="penaltySlabForm.controls.from_unit" [readonly]="readOnly()" placeholder="0" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label">To Quantum (MW) *</label>
                    <input class="form-control" type="number" step="0.01" [formControl]="penaltySlabForm.controls.to_unit" [readonly]="readOnly()" placeholder="20" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label">Rate (Rs) *</label>
                    <input class="form-control" type="number" step="0.01" [formControl]="penaltySlabForm.controls.rate" [readonly]="readOnly()" placeholder="2.13" />
                  </div>
                  @if (!readOnly()) {
                    <div class="col-md-3 d-flex gap-2">
                      <button type="button" class="btn btn-dark btn-sm" (click)="savePenaltySlab()">
                        {{ editingPenaltySlabId() ? 'Update Slab' : 'Add Slab' }}
                      </button>
                      <button type="button" class="btn btn-light btn-sm" (click)="cancelPenaltySlab()">Clear</button>
                    </div>
                  }
                </div>

                <div class="table-responsive module-table-wrap">
                  <table class="table table-sm align-middle mb-0 module-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>From Unit (MW)</th>
                        <th>To Unit (MW)</th>
                        <th>Rate / Unit (Rs)</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (sortedPenaltySlabs().length === 0) {
                        <tr><td colspan="5" class="text-muted text-center py-4 module-table-empty">No penalty slabs added</td></tr>
                      }
                      @for (row of sortedPenaltySlabs(); track row.id; let i = $index) {
                        <tr>
                          <td class="module-table__index">{{ i + 1 }}</td>
                          <td>{{ row.from_unit }}</td>
                          <td>{{ row.to_unit }}</td>
                          <td>{{ row.rate }}</td>
                          <td class="text-center">
                            @if (!readOnly()) {
                              <div class="module-table-actions">
                                <button type="button" class="btn btn-light btn-sm module-icon-btn" (click)="editPenaltySlab(row)"><lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon></button>
                                <button type="button" class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" (click)="removePenaltySlab(row.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            }
          </div>
        </div>

        @if (isBanking()) {
          @if (!hasBankingPriority()) {
            <div class="alert alert-info mb-0">Banking Priority is not selected yet, so both Import and Export schedules are shown.</div>
          }
          <div class="row g-3">
            @for (direction of bankingScheduleOrder(); track direction) {
              <div class="col-lg-6">
                <div class="card card-lift h-100">
                  <div class="card-header bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <div class="fw-semibold fs-5">{{ scheduleTitleByDirection(direction) }}</div>
                    </div>
                    @if (canAddSchedule(direction)) {
                      <button type="button" class="btn btn-sm btn-dark" (click)="editSchedule(null, direction)">
                        <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon><span class="ms-1 text-uppercase">{{ addScheduleButtonLabelByDirection(direction) }}</span>
                      </button>
                    }
                  </div>
                  <div class="card-body">
                    <div class="table-responsive module-table-wrap">
                      <table class="table table-sm align-middle mb-0 module-table">
                        <thead>
                          <tr>
                            <th>S.No.</th><th>From Date</th><th>To Date</th><th>From Time</th><th>To Time</th><th>Quantum (MW)</th>
                            @if (isSecondBankingDirection(direction)) { <th>Return %</th> }
                            <th>Arrangement</th><th class="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          @if (schedulesByDirection(direction).length === 0) { <tr><td [attr.colspan]="isSecondBankingDirection(direction) ? 9 : 8" class="text-muted text-center py-4 module-table-empty">No Data Found</td></tr> }
                          @for (item of schedulesByDirection(direction); track item.id; let i = $index) {
                            <tr>
                              <td class="module-table__index">{{ i + 1 }}</td><td>{{ formatDisplayDate(item.from_date) }}</td><td>{{ formatDisplayDate(item.to_date) }}</td><td>{{ item.from_time }}</td><td>{{ item.to_time }}</td><td>{{ item.quantum_mw || '-' }}</td>
                              @if (isSecondBankingDirection(direction)) { <td>{{ item.return_percentage ?? '-' }}</td> }
                              <td>{{ item.arrangement ?? '-' }}</td>
                              <td class="text-center">
                                @if (canEditSchedule(item) || canDeleteSchedule(item)) {
                                  <div class="module-table-actions">
                                    @if (canEditSchedule(item)) {
                                      <button type="button" class="btn btn-light btn-sm module-icon-btn" (click)="editSchedule(item, direction)"><lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon></button>
                                    }
                                    @if (canDeleteSchedule(item)) {
                                      <button type="button" class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" (click)="removeSchedule(item.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                                    }
                                  </div>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="row g-3">
            <div class="col-lg-6">
              <div class="card card-lift h-100">
                <div class="card-header bg-light d-flex justify-content-between align-items-center">
                  <div>
                    <div class="fw-semibold fs-5">{{ scheduleSectionTitle() }}</div>
                  </div>
                  @if (canAddSchedule()) {
                    <button type="button" class="btn btn-sm btn-dark" (click)="editSchedule(null)">
                      <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon><span class="ms-1 text-uppercase">{{ addScheduleButtonLabel() }}</span>
                    </button>
                  }
                </div>
                <div class="card-body">
                  <div class="table-responsive module-table-wrap">
                    <table class="table table-sm align-middle mb-0 module-table">
                      <thead>
                        <tr><th>S.No.</th><th>From Date</th><th>To Date</th><th>From Time</th><th>To Time</th><th>Quantum (MW)</th><th>Arrangement</th><th class="text-center">Actions</th></tr>
                      </thead>
                      <tbody>
                        @if (orderedDisplaySchedules().length === 0) { <tr><td colspan="8" class="text-muted text-center py-4 module-table-empty">No Data Found</td></tr> }
                        @for (item of orderedDisplaySchedules(); track item.id; let i = $index) {
                          <tr>
                            <td class="module-table__index">{{ i + 1 }}</td><td>{{ formatDisplayDate(item.from_date) }}</td><td>{{ formatDisplayDate(item.to_date) }}</td><td>{{ item.from_time }}</td><td>{{ item.to_time }}</td><td>{{ item.quantum_mw || '-' }}</td><td>{{ item.arrangement ?? '-' }}</td>
                            <td class="text-center">
                              @if (canEditSchedule(item) || canDeleteSchedule(item)) {
                                <div class="module-table-actions">
                                  @if (canEditSchedule(item)) {
                                    <button type="button" class="btn btn-light btn-sm module-icon-btn" (click)="editSchedule(item)"><lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon></button>
                                  }
                                  @if (canDeleteSchedule(item)) {
                                    <button type="button" class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" (click)="removeSchedule(item.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                                  }
                                </div>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card card-lift h-100">
                <div class="card-header emd-card-header d-flex justify-content-between align-items-center">
                  <div>
                    <div class="fw-semibold fs-5">Security Money Deposits</div>
                    <small class="emd-card-subtitle">Track deposit type, bank reference, and validity period in one place</small>
                  </div>
                  @if (canAddEmd()) {
                    <button type="button" class="btn btn-sm btn-dark emd-add-btn" (click)="editEmd(null)">
                      <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon><span class="ms-1 text-uppercase">Add Security Money Deposit</span>
                    </button>
                  }
                </div>
                <div class="card-body">
                  <div class="table-responsive module-table-wrap emd-table-wrap">
                    <table class="table table-sm align-middle mb-0 module-table emd-table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Deposit By</th>
                          <th>Issue Date</th>
                          <th>Duration</th>
                          <th>Amount</th>
                          <th>Bank Name</th>
                          <th>Reference</th>
                          <th class="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (displayEmds().length === 0) { <tr><td colspan="8" class="text-muted text-center py-4 emd-empty-state">No security money deposits found</td></tr> }
                        @for (item of displayEmds(); track item.id; let i = $index) {
                          <tr>
                            <td class="emd-table__index">{{ i + 1 }}</td>
                            <td><span class="emd-pill">{{ item.security_deposit_type }}</span></td>
                            <td><span class="emd-date">{{ formatDisplayDate(item.issue_date) }}</span></td>
                            <td>
                              <span class="emd-duration emd-duration--stacked">
                                <span>{{ formatDisplayDate(item.effective_from) }}</span>
                                <span class="emd-duration__separator">to</span>
                                <span>{{ formatDisplayDate(item.effective_to) }}</span>
                              </span>
                            </td>
                            <td>{{ billingCurrencyDisplay(item.amount) }}</td>
                            <td class="fw-medium">{{ item.bank_name }}</td>
                            <td><span class="emd-ref">{{ item.reference_number }}</span></td>
                            <td class="text-center">
                              @if (canEditEmd(item) || canDeleteEmd(item)) {
                                <div class="emd-actions">
                                  @if (canEditEmd(item)) {
                                    <button type="button" class="btn btn-light btn-sm emd-action-btn" (click)="editEmd(item)"><lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon></button>
                                  }
                                  @if (canDeleteEmd(item)) {
                                    <button type="button" class="btn btn-light btn-sm emd-action-btn emd-action-btn--danger" (click)="removeEmd(item.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                                  }
                                </div>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (!hideFinancialSectionsForOperation()) {
          <div class="card card-lift">
            <div class="card-header" style="background:#d6e3f2">
              <div class="fw-semibold fs-5">Billing</div>
              <div class="small">Billing Details (Bill First Configuration)</div>
            </div>
            <div class="card-body d-grid gap-3">
              <div class="border rounded p-2">
                <div class="fw-semibold mb-2">Applications Runs *</div>
                <div class="d-flex gap-3">
                  <label class="form-check-label d-flex align-items-center gap-2">
                    <input class="form-check-input" type="checkbox" [checked]="billingRuns().SOP" [disabled]="mode() !== 'new' && mode() !== 'edit'" (change)="toggleBillingRun('SOP', $any($event.target).checked)" />
                    SOP
                  </label>
                  <label class="form-check-label d-flex align-items-center gap-2">
                    <input class="form-check-input" type="checkbox" [checked]="billingRuns().TMR" [disabled]="mode() !== 'new' && mode() !== 'edit'" (change)="toggleBillingRun('TMR', $any($event.target).checked)" />
                    TMR
                  </label>
                  <label class="form-check-label d-flex align-items-center gap-2">
                    <input class="form-check-input" type="checkbox" [checked]="billingRuns().OA" [disabled]="mode() !== 'new' && mode() !== 'edit'" (change)="toggleBillingRun('OA', $any($event.target).checked)" />
                    OA
                  </label>
                </div>
              </div>

              <div class="row g-3">
              @if (billingRuns().SOP) {
                <div class="col-lg-4">
                  <div class="border rounded h-100">
                    <div class="d-flex justify-content-between align-items-center p-2" style="background:#efe3c7">
                      <strong>SOP Billing Configuration</strong>
                      <button type="button" class="btn btn-sm btn-dark" [disabled]="mode() !== 'new' && mode() !== 'edit'" (click)="openAddBilling('SOP')"><span class="text-uppercase">+ Add SOP Billing</span></button>
                    </div>
                    <div class="p-2">
                      @if (!hasBillingConfig('SOP')) {
                        <div class="alert alert-danger py-2 mb-0">At least one SOP billing configuration is required.</div>
                      } @else {
                        <div class="d-grid gap-2 overflow-auto pe-1" style="max-height: 320px;">
                          @for (config of billingConfigsFor('SOP'); track config.id; let idx = $index) {
                            <div class="border rounded p-2 small">
                              <div class="d-flex justify-content-between align-items-center mb-2">
                                <strong>S.No: {{ idx + 1 }}</strong>
                                @if (!readOnly()) {
                                  <div class="d-flex gap-1">
                                    @if (canEditBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="editBillConfig(config)">Edit</button>
                                    }
                                    @if (canDeleteBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="removeBillConfig(config.id)">Delete</button>
                                    }
                                  </div>
                                }
                              </div>
                              <div class="row g-2">
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Effective</strong><div>{{ formatDisplayDate(config.effective_date) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Bill Cycle</strong><div>{{ billingCycleDisplay(config.bill_cycle) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rate Type</strong><div>{{ billingRateTypeDisplay(config.rate_type) }}</div></div></div>
                                @if ((config.rate_type || '').toUpperCase() === 'FIXED') {
                                  <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rate</strong><div>{{ billingCurrencyDisplay(config.rate) }}</div></div></div>
                                } @else {
                                  <div class="col-6"><div class="border rounded px-2 py-1"><strong>MCP</strong><div>{{ billingFieldDisplay(config.mcp_condition) }}</div></div></div>
                                }
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Due Days</strong><div>{{ billingFieldDisplay(config.due_days) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate (%)</strong><div>{{ billingFieldDisplay(config.rebate) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate Days</strong><div>{{ billingFieldDisplay(config.rebate_days) }}</div></div></div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (billingRuns().TMR) {
                <div class="col-lg-4">
                  <div class="border rounded h-100">
                    <div class="d-flex justify-content-between align-items-center p-2" style="background:#efe3c7">
                      <strong>TMR Billing Configuration</strong>
                      <button type="button" class="btn btn-sm btn-dark" [disabled]="mode() !== 'new' && mode() !== 'edit'" (click)="openAddBilling('TMR')"><span class="text-uppercase">+ Add TMR Billing</span></button>
                    </div>
                    <div class="p-2">
                      @if (!hasBillingConfig('TMR')) {
                        <div class="alert alert-danger py-2 mb-0">At least one TMR billing configuration is required.</div>
                      } @else {
                        <div class="d-grid gap-2 overflow-auto pe-1" style="max-height: 320px;">
                          @for (config of billingConfigsFor('TMR'); track config.id; let idx = $index) {
                            <div class="border rounded p-2 small">
                              <div class="d-flex justify-content-between align-items-center mb-2">
                                <strong>S.No: {{ idx + 1 }}</strong>
                                @if (!readOnly()) {
                                  <div class="d-flex gap-1">
                                    @if (canEditBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="editBillConfig(config)">Edit</button>
                                    }
                                    @if (canDeleteBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="removeBillConfig(config.id)">Delete</button>
                                    }
                                  </div>
                                }
                              </div>
                              <div class="row g-2">
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Effective</strong><div>{{ formatDisplayDate(config.effective_date) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Bill Cycle</strong><div>{{ billingCycleDisplay(config.bill_cycle) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Due Days</strong><div>{{ billingFieldDisplay(config.due_days) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate (%)</strong><div>{{ billingFieldDisplay(config.rebate) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate Days</strong><div>{{ billingFieldDisplay(config.rebate_days) }}</div></div></div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (billingRuns().OA) {
                <div class="col-lg-4">
                  <div class="border rounded h-100">
                    <div class="d-flex justify-content-between align-items-center p-2" style="background:#cdd8f1">
                      <strong>OA Billing Configuration</strong>
                      <button type="button" class="btn btn-sm btn-dark" [disabled]="mode() !== 'new' && mode() !== 'edit'" (click)="openAddBilling('OA')"><span class="text-uppercase">+ Add OA Billing</span></button>
                    </div>
                    <div class="p-2">
                      @if (!hasBillingConfig('OA')) {
                        <div class="alert alert-danger py-2 mb-0">At least one OA billing configuration is required.</div>
                      } @else {
                        <div class="d-grid gap-2 overflow-auto pe-1" style="max-height: 320px;">
                          @for (config of billingConfigsFor('OA'); track config.id; let idx = $index) {
                            <div class="border rounded p-2 small">
                              <div class="d-flex justify-content-between align-items-center mb-2">
                                <strong>S.No: {{ idx + 1 }}</strong>
                                @if (!readOnly()) {
                                  <div class="d-flex gap-1">
                                    <button type="button" class="btn btn-light btn-sm" (click)="openOaChargesView(config)">View Charges</button>
                                    @if (canEditBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="editBillConfig(config)">Edit</button>
                                    }
                                    @if (canDeleteBillConfigItem(config)) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="removeBillConfig(config.id)">Delete</button>
                                    }
                                  </div>
                                }
                              </div>
                              <div class="row g-2">
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Effective</strong><div>{{ formatDisplayDate(config.effective_date) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Bill Cycle</strong><div>{{ billingCycleDisplay(config.bill_cycle) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Due Days</strong><div>{{ billingFieldDisplay(config.due_days) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate (%)</strong><div>{{ billingFieldDisplay(config.rebate) }}</div></div></div>
                                <div class="col-6"><div class="border rounded px-2 py-1"><strong>Rebate Days</strong><div>{{ billingFieldDisplay(config.rebate_days) }}</div></div></div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              </div>
            </div>
          </div>
        }

        <div class="row g-3">
          <div [class.col-12]="!isBanking()" [class.col-lg-6]="isBanking()">
              <div class="card card-lift h-100">
                <div class="card-header d-flex justify-content-between align-items-center" style="background:#d6e3f2">
                  <div>
                    <div class="fw-semibold fs-5">Documents</div>
                    <div class="small">Configure LOA default document requirements</div>
                  </div>
                  <div class="d-flex gap-2">
                    @if (canManageLoaUploads()) {
                      <button type="button" class="btn btn-dark btn-sm text-uppercase" (click)="addLoaDocument()">+ Upload LOA Document</button>
                    }
                  </div>
                </div>
                <div class="card-body">
                  @if (missingMandatoryLoaDocumentNames().length) {
                    <div class="alert alert-danger mb-0 py-2">
                      Missing mandatory {{ selectedCategory() }} LOA documents:
                      {{ missingMandatoryLoaDocumentNames().join(', ') }}
                    </div>
                  }
                  <h6 class="mt-3 mb-2">Uploaded LOA Documents</h6>
                  <div class="table-responsive module-table-wrap">
                    <table class="table table-sm align-middle mb-0 module-table">
                      <thead>
                        <tr><th>S.No.</th><th>Document Type</th><th>File Name</th><th>Size</th><th class="text-center">Actions</th></tr>
                      </thead>
                      <tbody>
                        @if (loaDocumentRows().length === 0) { <tr><td colspan="5" class="text-muted text-center py-4 module-table-empty">No uploaded documents</td></tr> }
                        @for (doc of loaDocumentRows(); track doc.key; let i = $index) {
                          <tr>
                            <td class="module-table__index">{{ i + 1 }}</td>
                            <td>{{ doc.documentType }}</td>
                            <td>{{ doc.originalName }}</td>
                            <td>{{ doc.fileSize !== null ? ((doc.fileSize / 1024).toFixed(1) + ' KB') : '-' }}</td>
                            <td class="text-center">
                              @if (!readOnly()) {
                                @if (doc.uploaded && doc.id) {
                                  <div class="module-table-actions">
                                    <button type="button" class="btn btn-light btn-sm" (click)="downloadLoaDocument(doc.id)"><span>Download</span></button>
                                    @if (canManageLoaUploads()) {
                                      <button type="button" class="btn btn-light btn-sm" (click)="addLoaDocument(doc.documentType)"><span>Re-upload</span></button>
                                    }
                                    <button type="button" class="btn btn-light btn-sm module-icon-btn module-icon-btn--danger" (click)="removeLoaDocument(doc.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                                  </div>
                                } @else if (canManageLoaUploads()) {
                                  <button type="button" class="btn btn-light btn-sm" (click)="addLoaDocument(doc.documentType)"><span>Upload</span></button>
                                }
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            @if (isBanking()) {
              <div class="col-lg-6">
              <div class="card card-lift h-100">
                <div class="card-header emd-card-header d-flex justify-content-between align-items-center">
                  <div>
                    <div class="fw-semibold fs-5">Security Money Deposits</div>
                    <small class="emd-card-subtitle">Track deposit type, bank reference, and validity period in one place</small>
                  </div>
                  @if (canAddEmd()) {
                    <button type="button" class="btn btn-sm btn-dark emd-add-btn" (click)="editEmd(null)">
                      <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon><span class="ms-1 text-uppercase">Add Security Money Deposit</span>
                    </button>
                  }
                </div>
                <div class="card-body">
                  <div class="table-responsive module-table-wrap emd-table-wrap">
                    <table class="table table-sm align-middle mb-0 module-table emd-table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Deposit By</th>
                          <th>Issue Date</th>
                          <th>Duration</th>
                          <th>Amount</th>
                          <th>Bank Name</th>
                          <th>Reference</th>
                          <th class="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (displayEmds().length === 0) { <tr><td colspan="8" class="text-muted text-center py-4 emd-empty-state">No security money deposits found</td></tr> }
                        @for (item of displayEmds(); track item.id; let i = $index) {
                          <tr>
                            <td class="emd-table__index">{{ i + 1 }}</td>
                            <td><span class="emd-pill">{{ item.security_deposit_type }}</span></td>
                            <td><span class="emd-date">{{ formatDisplayDate(item.issue_date) }}</span></td>
                            <td>
                              <span class="emd-duration emd-duration--stacked">
                                <span>{{ formatDisplayDate(item.effective_from) }}</span>
                                <span class="emd-duration__separator">to</span>
                                <span>{{ formatDisplayDate(item.effective_to) }}</span>
                              </span>
                            </td>
                            <td>{{ billingCurrencyDisplay(item.amount) }}</td>
                            <td class="fw-medium">{{ item.bank_name }}</td>
                            <td><span class="emd-ref">{{ item.reference_number }}</span></td>
                            <td class="text-center">
                              @if (canEditEmd(item) || canDeleteEmd(item)) {
                                <div class="emd-actions">
                                  @if (canEditEmd(item)) {
                                    <button type="button" class="btn btn-light btn-sm emd-action-btn" (click)="editEmd(item)"><lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon></button>
                                  }
                                  @if (canDeleteEmd(item)) {
                                    <button type="button" class="btn btn-light btn-sm emd-action-btn emd-action-btn--danger" (click)="removeEmd(item.id)"><lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon></button>
                                  }
                                </div>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              </div>
            }
          </div>

        @if (showScheduleForm()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1040;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:820px;z-index:1050;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">{{ scheduleModalTitle() }}</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="cancelSchedule()">✕</button>
              </div>
              <div class="card-body">
                <div class="row g-2" [formGroup]="scheduleForm">
                  <div class="col-md-6"><label class="form-label">From Date *</label><input class="form-control" type="date" formControlName="from_date" /></div>
                  <div class="col-md-6"><label class="form-label">To Date *</label><input class="form-control" type="date" formControlName="to_date" /></div>
                  <div class="col-md-6">
                    <label class="form-label">From Time *</label>
                    <select class="form-select" formControlName="from_time">
                      <option value="" disabled>Select From Time</option>
                      <option *ngFor="let item of fromTimeOptions" [value]="item">{{ item }}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">To Time *</label>
                    <select class="form-select" formControlName="to_time">
                      <option value="" disabled>Select To Time</option>
                      <option *ngFor="let item of toTimeOptions" [value]="item">{{ item }}</option>
                    </select>
                  </div>
                  <div class="col-md-6"><label class="form-label">Quantum (MW) *</label><input class="form-control" formControlName="quantum_mw" placeholder="Quantum (MW)" /></div>
                  <div class="col-md-6">
                    <label class="form-label">Arrangement *</label>
                    <select class="form-select" formControlName="arrangement">
                      <option value="" disabled>Select Arrangement</option>
                      <option *ngFor="let item of arrangementOptions(currentScheduleDirection())" [value]="item.toString()">{{ item }}</option>
                    </select>
                  </div>
                  @if (isBanking() && isSecondBankingDirection(activeScheduleDirection())) {
                    <div class="col-md-6"><label class="form-label">Return Percentage (%)</label><input class="form-control" type="number" step="0.01" formControlName="return_percentage" placeholder="Return Percentage" /></div>
                  }
                  @if (isBanking()) {
                    <div class="col-md-6 d-none">
                      <label class="form-label">Direction *</label>
                      <input class="form-control text-capitalize" [value]="activeScheduleDirection()" readonly />
                    </div>
                  } @else {
                    <div class="col-md-6 d-none"><label class="form-label">Direction *</label><select class="form-select" formControlName="direction" (change)="onScheduleDirectionChange(($any($event.target).value || '').toString())"><option value="import">Import</option><option value="export">Export</option></select></div>
                  }
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-outline-secondary" (click)="cancelSchedule()">CANCEL</button>
                  <button type="button" class="btn btn-primary" [disabled]="scheduleForm.invalid" (click)="saveSchedule()">{{ editingScheduleId() ? 'UPDATE' : 'ADD' }}</button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (showEmdForm()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1040;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:820px;z-index:1050;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">Security Money Deposit</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="cancelEmd()">✕</button>
              </div>
              <div class="card-body">
                <div class="row g-2" [formGroup]="emdForm">
                  <div class="col-md-3"><label class="form-label">Issue Date *</label><input class="form-control" type="date" formControlName="issue_date" /></div>
                  <div class="col-md-3">
                    <label class="form-label">Deposit By *</label>
                    <select class="form-select" formControlName="security_deposit_type">
                      <option value="" disabled>Select Deposit By</option>
                      @for (item of depositByOptions; track item) {
                        <option [value]="item">{{ item }}</option>
                      }
                    </select>
                  </div>
                  <div class="col-md-3"><label class="form-label">Bank Name *</label><input class="form-control" formControlName="bank_name" placeholder="Enter Bank Name" /></div>
                  <div class="col-md-3"><label class="form-label">Reference Number *</label><input class="form-control" formControlName="reference_number" placeholder="Reference Number" /></div>
                  <div class="col-md-3"><label class="form-label">Enter Amount *</label><input class="form-control" formControlName="amount" placeholder="Enter Amount" /></div>
                  <div class="col-md-3"><label class="form-label">Effective From *</label><input class="form-control" type="date" formControlName="effective_from" /></div>
                  <div class="col-md-3"><label class="form-label">Effective To *</label><input class="form-control" type="date" formControlName="effective_to" /></div>
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-light" (click)="cancelEmd()">CANCEL</button>
                  <button type="button" class="btn btn-dark" [disabled]="emdForm.invalid" (click)="saveEmd()">{{ editingEmdId() ? 'UPDATE' : 'SAVE' }}</button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (showDocumentForm()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1040;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:780px;z-index:1050;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">LOA Document Configuration</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="cancelDocumentConfig()">✕</button>
              </div>
              <div class="card-body">
                <div class="row g-2" [formGroup]="documentForm">
                  <div class="col-md-3">
                    <label class="form-label">Module Name *</label>
                    <input class="form-control" formControlName="module_name" readonly />
                  </div>
                  <div class="col-md-4"><label class="form-label">Document Title *</label><input class="form-control" formControlName="doc_title" placeholder="Document Title" /></div>
                  <div class="col-md-3">
                    <label class="form-label">Client Types *</label>
                    <input class="form-control" formControlName="client_types" placeholder="Buy, Sell, Banking" />
                  </div>
                  <div class="col-md-2"><label class="form-label">Status *</label><select class="form-select" formControlName="status">@for (item of docStatusOptions; track item) { <option [value]="item">{{ item }}</option> }</select></div>
                  <div class="col-md-4"><label class="form-label">Allowed File Types *</label><input class="form-control" formControlName="allowed_file_types" placeholder="PDF, DOCX" /></div>
                  <div class="col-md-2"><label class="form-label">Max File Size (MB) *</label><input class="form-control" type="number" min="1" formControlName="max_file_size_mb" /></div>
                  <div class="col-md-3"><label class="form-label">Effective Date</label><input class="form-control" type="date" formControlName="effective_date" /></div>
                  <div class="col-md-3 d-flex align-items-center gap-2 pt-4">
                    <input class="form-check-input" type="checkbox" id="docMandatory" formControlName="mandatory" />
                    <label class="form-check-label" for="docMandatory">Mandatory</label>
                  </div>
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-light" (click)="cancelDocumentConfig()">CANCEL</button>
                  <button type="button" class="btn btn-primary" [disabled]="documentForm.invalid" (click)="saveDocumentConfig()">{{ editingDocumentConfigId() ? 'UPDATE' : 'SAVE' }}</button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (showDocumentUploadForm()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1040;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:820px;z-index:1050;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">Upload LOA Document</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="closeDocumentUploadForm()">✕</button>
              </div>
              <div class="card-body">
                <div class="row g-2">
                  <div class="col-md-4">
                    <label class="form-label">Document Type *</label>
                    <select class="form-select" [value]="selectedUploadDocType()" (change)="onUploadDocTypeChange(($any($event.target).value || '').toString())">
                      @for (item of loaUploadTypeOptions(); track item) {
                        <option [value]="item">{{ item }}</option>
                      }
                    </select>
                  </div>
                  @if (selectedUploadDocType() === 'Other') {
                    <div class="col-md-4">
                      <label class="form-label">Other Document Name *</label>
                      <input class="form-control" [value]="selectedUploadOtherDocType()" (input)="onUploadOtherDocTypeChange(($any($event.target).value || '').toString())" />
                    </div>
                  }
                  <div class="col-md-4">
                    <label class="form-label">File(s) *</label>
                    <input class="form-control" type="file" multiple (change)="onLoaDocumentFileChange($event)" />
                  </div>
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-light" (click)="closeDocumentUploadForm()">CANCEL</button>
                  <button type="button" class="btn btn-primary" [disabled]="uploadingLoaDocument()" (click)="uploadLoaDocument()">{{ uploadingLoaDocument() ? 'UPLOADING...' : 'UPLOAD' }}</button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (showBillForm()) {
          <div class="loa-modal-overlay" style="z-index:1040;"></div>
          <div class="loa-modal-shell" style="z-index:1050;">
            <div class="loa-modal-dialog" style="max-width:820px;">
            <div class="card border-0 shadow loa-modal-card">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">{{ billtypemodal }} Billing Configuration</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="cancelBillConfig()">✕</button>
              </div>
              <div class="card-body loa-modal-body" [formGroup]="billConfigForm">
                <div class="row g-2">
                  <div class="col-md-6">
                    <label class="form-label">From Date *</label>
                    <input class="form-control" type="date" formControlName="effective_date" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Bill Cycle *</label>
                    <div class="input-group">
                      <select class="form-select" formControlName="bill_cycle" (change)="onBillCycleChange(($any($event.target).value || '').toString())">
                        <option value="" disabled>Select Bill Cycle</option>
                        @for (item of billCycleOptionsForCurrentType(); track item) { <option [value]="item">{{ item }}</option> }
                      </select>
                      <button type="button" class="btn btn-outline-secondary" (click)="openBillCycleView()">View</button>
                    </div>
                  </div>

                  @if (isSopBilling()) {
                    <div class="col-md-6">
                      <label class="form-label">Rate Type *</label>
                      <select class="form-select" formControlName="rate_type" (change)="onBillRateTypeChange(($any($event.target).value || '').toString())">
                        @for (item of sopRateTypeOptions; track item) { <option [value]="item">{{ item }}</option> }
                      </select>
                    </div>
                    
                    
                    @if (isSopMcpBilling()) {
                      <div class="col-md-6">
                        <label class="form-label">MCP Condition *</label>
                        <select
                          class="form-select"
                          formControlName="mcp_condition"
                          (change)="onMcpConditionChange(($any($event.target).value || '').toString())"
                        >
                          <option value="" disabled>Select MCP Condition</option>
                          @for (item of billingMcpConditionOptions; track item) { <option [value]="item">{{ item }}</option> }
                        </select>
                      </div>
                    }
                  }

                  @if (isTmrBilling()) {
                    <div class="col-12">
                      <div class="small text-muted">TMR billing configuration is independent of SOP MCP rules.</div>
                    </div>
                  }
                  @if (billtypemodal !== 'OA') {
                    <div class="col-md-6">
                      <label class="form-label">Rate (Rupees) *</label>
                      <input class="form-control" formControlName="rate" placeholder="In Rupees" [readonly]="isRateValueLocked()" />
                    </div>
                  }
                  <div class="col-md-6">
                    <label class="form-label">Payment Due Days *</label>
                    <input class="form-control" formControlName="due_days" placeholder="Due Days" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Rebate (%)*</label>
                    <input class="form-control" formControlName="rebate" placeholder="Rebate" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Rebate Days *</label>
                    <input class="form-control" formControlName="rebate_days" placeholder="Rebate Days" />
                  </div>
                  @if (isOaBilling()) {
                    <div class="col-md-6">
                      <label class="form-label">Discount Price *</label>
                      <input class="form-control" formControlName="discount_price" placeholder="Discount Price" />
                    </div>
                    <div class="col-12">
                      <div class="border rounded p-2">
                        <h6 class="mb-2">OA Charge Allocation Preference</h6>
                        <div class="table-responsive module-table-wrap">
                          <table class="table table-sm mb-0 module-table">
                            <thead>
                              <tr><th>Charge Type</th><th>Payer</th><th>Buyer %</th><th>Seller %</th></tr>
                            </thead>
                            <tbody>
                              @for (row of oaChargeAllocations(); track row.charge_type; let i = $index) {
                                <tr>
                                  <td>{{ row.charge_type }}</td>
                                  <td>
                                    <select class="form-select form-select-sm" [value]="row.payer" (change)="updateOaAllocation(i, 'payer', ($any($event.target).value || '').toString())">
                                      <option value="Shared">Shared</option>
                                      <option value="Buyer">Buyer</option>
                                      <option value="Seller">Seller</option>
                                    </select>
                                  </td>
                                  <td><input class="form-control form-control-sm" type="number" [value]="row.buyer_percent" (input)="updateOaAllocation(i, 'buyer_percent', ($any($event.target).value || '').toString())" /></td>
                                  <td><input class="form-control form-control-sm" type="number" [value]="row.seller_percent" (input)="updateOaAllocation(i, 'seller_percent', ($any($event.target).value || '').toString())" /></td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                        @if (invalidOaRows().length > 0) {
                          <div class="text-danger small mt-2">Buyer % + Seller % must be 100 for each row.</div>
                        }
                      </div>
                    </div>
                  }
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" class="btn btn-light" (click)="cancelBillConfig()">CANCEL</button>
                  <button type="button" class="btn btn-primary" [disabled]="billConfigForm.invalid" (click)="saveBillConfig()">{{ editingBillConfigId() ? 'UPDATE' : 'ADD' }}</button>
                </div>
              </div>
            </div>
            </div>
          </div>
        }

        @if (showBillCycleViewModal()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1060;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:640px;z-index:1070;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">Bill Cycle View - {{ selectedBillCycle() || 'N/A' }}</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="closeBillCycleView()">✕</button>
              </div>
              <div class="card-body">
                @if (canEditCustomRanges()) {
                  <div class="row g-2 mb-3">
                    <div class="col-md-4"><label class="form-label">From</label><input class="form-control" [formControl]="rangeEditor.controls.from" /></div>
                    <div class="col-md-4"><label class="form-label">To</label><input class="form-control" [formControl]="rangeEditor.controls.to" /></div>
                    <div class="col-md-4 d-grid align-items-end">
                      <button type="button" class="btn btn-primary mt-4" (click)="addOrUpdateCycleRange()">{{ editingCycleRangeId() ? 'Update Range' : 'Add Range' }}</button>
                    </div>
                  </div>
                }
                <div class="table-responsive module-table-wrap">
                  <table class="table table-sm mb-0 module-table">
                    <thead>
                      <tr><th>From</th><th>To</th>@if (canEditCustomRanges()) { <th class="text-center">Actions</th> }</tr>
                    </thead>
                    <tbody>
                      @if (cycleRangesForPreview().length === 0) {
                        <tr><td colspan="3" class="text-center text-muted module-table-empty">No ranges</td></tr>
                      }
                      @for (row of cycleRangesForPreview(); track row.id) {
                        <tr>
                          <td>{{ row.from }}</td>
                          <td>{{ row.to }}</td>
                          @if (canEditCustomRanges()) {
                            <td class="text-center">
                              <div class="module-table-actions">
                                <button type="button" class="btn btn-sm btn-light" (click)="editCycleRange(row)">Edit</button>
                                <button type="button" class="btn btn-sm btn-light" (click)="removeCycleRange(row.id)">Delete</button>
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-secondary" (click)="closeBillCycleView()">Close</button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (showOaChargesViewModal()) {
          <div class="position-fixed top-0 start-0 w-100 h-100" style="background:rgba(0,0,0,.35);z-index:1060;"></div>
          <div class="position-fixed top-50 start-50 translate-middle w-100 px-2" style="max-width:760px;z-index:1070;">
            <div class="card border-0 shadow">
              <div class="card-header d-flex justify-content-between align-items-center" style="background:#3653d8;color:#111827;">
                <h5 class="m-0">OA Charge Allocation Preference</h5>
                <button type="button" class="btn btn-sm btn-dark px-2 py-1" (click)="closeOaChargesView()">✕</button>
              </div>
              <div class="card-body">
                <div class="table-responsive module-table-wrap">
                  <table class="table table-sm mb-0 module-table">
                    <thead>
                      <tr><th>Charge Type</th><th>Payer</th><th>Buyer %</th><th>Seller %</th></tr>
                    </thead>
                    <tbody>
                      @for (row of oaChargeViewRows(); track row.charge_type) {
                        <tr>
                          <td>{{ row.charge_type }}</td>
                          <td>{{ row.payer }}</td>
                          <td>{{ row.buyer_percent }}</td>
                          <td>{{ row.seller_percent }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-secondary" (click)="closeOaChargesView()">Close</button>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="loa-form-actions d-flex justify-content-end gap-2">
          @if (loaId()) {
            <span class="badge text-uppercase d-inline-flex align-items-center me-auto"
              [class.text-bg-secondary]="displayLoaStatus() === 'draft'"
              [class.text-bg-warning]="displayLoaStatus() === 'pending_initial_approval' || displayLoaStatus() === 'pending_accounts_approval' || displayLoaStatus() === 'pending_operation_approval'"
              [class.text-bg-success]="displayLoaStatus() === 'final_approved' || displayLoaStatus() === 'approved'"
              [class.text-bg-danger]="displayLoaStatus() === 'rejected'">
              {{ displayLoaStatus() }}
            </span>
          }
          <button class="btn btn-outline-secondary" type="button" (click)="router.navigateByUrl('/loas')">Cancel</button>
          @if (mode() === 'view' && loaId()) {
            @if (canShowApprovalActions()) {
              <button class="btn btn-danger" type="button" [disabled]="loading()" (click)="rejectLoa()">
                <span>{{ loading() ? 'Processing...' : (canInitialApprove() ? 'Initial Reject' : (canAccountsApprove() ? 'Accounts Reject' : 'Operation Reject')) }}</span>
              </button>
              <button class="btn btn-success" type="button" [disabled]="loading()" (click)="approveLoa()">
                <span>{{ loading() ? 'Processing...' : (canInitialApprove() ? 'Initial Approve' : (canAccountsApprove() ? 'Accounts Approve' : 'Operation Approve')) }}</span>
              </button>
            }
            @if (canEditCurrentLoa()) {
              <button class="btn btn-primary" type="button" (click)="router.navigateByUrl('/loas/' + loaId() + '/edit')">
                <lucide-icon [img]="PencilIcon" [size]="15"></lucide-icon><span class="ms-2">Edit</span>
              </button>
            }
          } @else {
            <button class="btn btn-primary" [disabled]="form.invalid || loading()">
              <lucide-icon [img]="SaveIcon" [size]="15"></lucide-icon>
              <span class="ms-2">{{ loading() ? 'Saving...' : (mode() === 'new' ? 'SUBMIT FOR APPROVAL' : 'Update') }}</span>
            </button>
          }
        </div>
      </form>
    }
  </div>
</div>
